import { fileBaseUrl } from "../../../constants"

const resourceData = {
    featureList: [
        {
            videoUrl: fileBaseUrl + "/static/media/general/video/See GA Differently DSE- Visual progression of GA video.mp4",
            thumbNailUrl: fileBaseUrl + "/static/media/general/video/See GA Differently DSE- Visual progression of GA video.png",
            title: "Disease Progression",
            description: "See how GA progresses over time and how it may affect a patient’s vision, daily activities, and independence.",
            isDownloadAvailable: false
        },
        {
            videoUrl: fileBaseUrl + "/static/media/general/video/ComplementAnimation_Hypercept.mp4",
            thumbNailUrl: fileBaseUrl + "/static/media/general/video/ComplementAnimation_Hypercept.png",
            title: "Complement Pathway",
            description: "Further explore the role C3 and C5 play in the complement pathway and GA.",
            isDownloadAvailable: false
        }
    ],
    offlineResources: [
        {
            title: "Patient Identification and Referral Guide",
            fileUrl: fileBaseUrl + "/static/media/general/pdf/Ophthalmic DSE Patient Identification and Referral Guide.pdf"
        },
        {
            title: "Geographic Atrophy (GA): Imaging Guide for Early Detection and Monitoring",
            fileUrl: fileBaseUrl + "/static/media/general/pdf/Astellas Ophthalmics DSE Imaging Guide.pdf"
        }
    ]
}
export default resourceData